import { Listbox, ListboxOption, ListboxValue, Spinner } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import { MandateCustomer, Segment } from '../CommonInterfaces';
import useStores from '../stores/UseStores';
import { runInTeliaRumService } from '../util/TeliaOtelUtil';

interface DealerMandateListItemsProps {
  b2cMandates: MandateCustomer[];
  b2bMandates: MandateCustomer[];
}

const DealerMandateListItems = observer((props: DealerMandateListItemsProps): React.JSX.Element => {
  const { b2cMandates, b2bMandates } = props;
  const {
    translateStore: { translate },
    dealerRepresentationStore,
  } = useStores();

  const selectMandate = (listboxValue: ListboxValue) => {
    const segment: Segment = listboxValue?.split('-').shift()?.toUpperCase() as Segment;
    runInTeliaRumService(`Teenindaja esindatava vahetamine (${segment === 'B2B' ? 'Äriklient' : 'Eraklient'})`, () => {
      const index: number = +(listboxValue?.split('-').pop() || 0);
      const customer: MandateCustomer = (segment === 'B2B' ? b2bMandates : b2cMandates)[index];
      dealerRepresentationStore.selectCustomer(customer);
    });
  };

  const getSelectedMandateValue = () => {
    const b2cMandate = b2cMandates.find((customer) => customer.selected);
    if (b2cMandate) {
      return `b2c-mandate-list-item-${b2cMandates.indexOf(b2cMandate)}`;
    }
    const b2bMandate = b2bMandates.find((customer) => customer.selected);
    if (b2bMandate) {
      return `b2b-mandate-list-item-${b2bMandates.indexOf(b2bMandate)}`;
    }
    return null;
  };
  if (dealerRepresentationStore.isRepresentativeChanging) {
    return <Spinner />;
  }

  return (
    <Listbox aria-labelledby="mandates-title" value={getSelectedMandateValue()} onChange={selectMandate}>
      {b2cMandates.map(
        (item: MandateCustomer, index: number): React.JSX.Element => (
          <ListboxOption
            key={`b2c-mandate-list-item-${index}`}
            value={`b2c-mandate-list-item-${index}`}
            label={item.displayName}
            description={`${translate('mandates.b2c')}, ${item.registrationNumber} - ${item.registrationNumberCountryCode}`}
            icon="#contact"
          />
        ),
      )}
      {b2bMandates.map(
        (item: MandateCustomer, index: number): React.JSX.Element => (
          <ListboxOption
            key={`b2b-mandate-list-item-${index}`}
            value={`b2b-mandate-list-item-${index}`}
            label={item.displayName}
            description={`${translate('mandates.b2b')}, ${item.registrationNumber} - ${item.registrationNumberCountryCode}`}
            icon="#business-services"
          />
        ),
      )}
    </Listbox>
  );
});

export default DealerMandateListItems;
